import { withTranslation } from 'react-i18next';

import OrderSummary from './OrderSummary';

export default withTranslation()(OrderSummary);
